import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex gap-2',
    price: '',
    oldPrice: 'font-normal text-gray-500 line-through'
  },
  variants: {
    theme: {
      default: {},
      predator: {}
    }
  },
  defaultVariants: {
    theme: 'default'
  }
});
